var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notice-management" },
    [
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleAddNotice } },
            [_vm._v("\n      添加公告\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.loadConfig } },
            [_vm._v("\n      查询\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "99%" },
          attrs: { data: _vm.noticeList, border: "", height: "500" },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "id",
              label: "ID",
              "min-width": "100",
              fixed: "left",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "标题", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "title-display" }, [
                      _c("span", { staticClass: "tag-name" }, [
                        _vm._v(_vm._s(scope.row.extra.tagName)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "title-name" }, [
                        _vm._v(_vm._s(scope.row.extra.title)),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "星期", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            (scope.row.extra.selectedWeekdays || []).join("、")
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "时间段", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "time-range" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.extra.startTime) +
                          " - " +
                          _vm._s(scope.row.extra.endTime) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "显示", "min-width": "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-color": "#67C23A",
                        "inactive-color": "#dcdfe6",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleToggleVisibility(scope.row)
                        },
                      },
                      model: {
                        value: scope.row.enable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enable", $$v)
                        },
                        expression: "scope.row.enable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "添加时间", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.createTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleGenerateQrCode(scope.row)
                          },
                        },
                      },
                      [_vm._v("预览")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.handleRemove(scope.row)
                          },
                        },
                      },
                      [_vm._v("移除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "action-buttons" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "noticeForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "星期", prop: "weekdays" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.formData.selectedWeekdays,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "selectedWeekdays", $$v)
                        },
                        expression: "formData.selectedWeekdays",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "1" } }, [
                        _vm._v("1"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "2" } }, [
                        _vm._v("2"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "3" } }, [
                        _vm._v("3"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "4" } }, [
                        _vm._v("4"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "5" } }, [
                        _vm._v("5"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "6" } }, [
                        _vm._v("6"),
                      ]),
                      _vm._v(" "),
                      _c("el-checkbox", { attrs: { label: "7" } }, [
                        _vm._v("7"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "营业时间" } }, [
                _c(
                  "div",
                  { staticClass: "business-hours-picker" },
                  [
                    _c("el-time-picker", {
                      attrs: {
                        placeholder: "开始时间",
                        format: "HH:mm",
                        "value-format": "HH:mm",
                      },
                      model: {
                        value: _vm.formData.startTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "startTime", $$v)
                        },
                        expression: "formData.startTime",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "time-separator" }, [
                      _vm._v(":"),
                    ]),
                    _vm._v(" "),
                    _c("el-time-picker", {
                      attrs: {
                        placeholder: "结束时间",
                        format: "HH:mm",
                        "value-format": "HH:mm",
                      },
                      model: {
                        value: _vm.formData.endTime,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "endTime", $$v)
                        },
                        expression: "formData.endTime",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "标题", prop: "title" } }, [
                _c(
                  "div",
                  { staticClass: "title-inputs" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入标签名" },
                      model: {
                        value: _vm.formData.tagName,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "tagName", $$v)
                        },
                        expression: "formData.tagName",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: { placeholder: "请输入标题名" },
                      model: {
                        value: _vm.formData.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "title", $$v)
                        },
                        expression: "formData.title",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "内容", prop: "content" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入内容",
                      resize: "vertical",
                    },
                    model: {
                      value: _vm.formData.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "content", $$v)
                      },
                      expression: "formData.content",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否显示" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formData.isDisplayed,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "isDisplayed", $$v)
                        },
                        expression: "formData.isDisplayed",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("是"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("否"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "二维码预览",
            visible: _vm.qrCodeDialogVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrCodeDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "qr-code-container" }, [
            _vm.qrCodeImage
              ? _c("img", {
                  staticClass: "qr-code-image",
                  attrs: { src: _vm.qrCodeImage, alt: "二维码" },
                })
              : _c("div", { staticClass: "qr-code-placeholder" }, [
                  _c("i", { staticClass: "el-icon-loading" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("二维码生成中...")]),
                ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.qrCodeDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }